import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热播榜单', href: '#ranking' },
  { label: '最新快讯', href: '#updates' },
  { label: '平台特色', href: '#features' },
  { label: '热门话题', href: '#topics' },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header navItems={navItems} />

      <main>
        <HeroSection />
        <RankingSection />
        <MediaSection />
        <FAQSection />
        <CardsSection />
        <ContactSection />
        <FeaturesSection />
        <AppSection />
        <AboutSection />
        <TopicsSection />
        <CommentsSection />
        <CarouselSection />
        <IndexSection />
        <UpdatesSection />
      </main>

      <Footer />
    </div>
  );
}